export enum CustomMetricsName {
    ENTRY_URL = 'entryURL',
    APPLICATION = 'application',
    VIEW_KEY = 'viewKey',
    METHOD_PAYMENT = 'methodPayment',
    CALCULATION_DATA = 'calculationData',
    REGISTRATION_DATA = 'registrationData',
    OFFER_DETAILS = 'offerDetails',
    OFFERS_COMPARISON = 'offersComparison',
    ORDER_CONVERSATION = 'orderConversation', // TODO after ordering conversation implementation
    SELECT_OFFER = 'selectOffer',
    SEND_OFFER = 'sendOffer', // TODO after sending offer implementation
    REMOVE_OFFER_FROM_COMPARISON = 'removeOfferFromComparison',
    ALL_OFFER_AGREEMENTS = 'allOfferAgreements',
    INCORRECT_OFFER = 'incorrectOffer',
    NEXT_STEP_BUTTON = 'nextStepButton',
    WEBSOCKET_NOTIFICATION = 'websocketNotification', // payment status from websocket
    SESSION_NOTIFICATION = 'sessionNotification', // payment status from session
    NOTIFICATION_COMPONENT = 'notificationComponent', // metric triggered by notification component init
    SESSION_RESPONSE = 'sessionResponse', // response for session requests (non-status-based requests),
    OFFER_MATCHING_RESULT = 'offerMatchingResult', // result of matching offer from url (offerId)
    PAYMENT_ACCEPTANCE = 'paymentAcceptance', // payment acceptance user decision
    INSURER_DATA_AUTHORIZATION = 'insurerDataAuthorization', // insurer data authorization user decision
    AZTEC_DATA = 'aztecData', // data collected from aztec scanning
    AZTEC_SCANNER_DECISION = 'aztecScannerDecision', // aztec scanner modal user decision (scan/write data/cancel scanning)
    AZTEC_LIBRARY_RESPONSE = 'aztecLibraryResponse', // data from aztec library
    AZTEC_SCANNER_NEPTIS_CALLBACK = 'aztecScannerNeptisCallback', // data from aztec library
    CAMERA_INIT_ERROR = 'cameraInitError', // error while initializing device's camera on aztec scanner modal
    STEP_INIT = 'stepInit', // step initialization
    INITIAL_MODIFICATIONS = 'initialModifications',
    MODIFIED_OFFER = 'modifiedOffer',
    MODIFIED_ERROR_OFFER = 'modifiedErrorOffer',
    MODIFIED_CHANGED_PRICE_OFFER = 'modifiedChangedPriceOffer',
    APPLICATION_EVENT = 'applicationEvent',
    INITIAL_APPLICATION_STATE = 'initialApplicationState',
    PDF_VIEWER_ERROR = 'pdfViewerError',
    LOADING_SCRIPT_ERROR = 'loadingScriptError',
    LOADING_SCRIPT_SUCCESS = 'loadingScriptSuccess',
    GLOBAL_ERROR = 'globalError',
    UNHANDLED_REJECTION = 'unhandledRejection',
}
